<template>
  <div class="wallet-title">
    <div class="wallet-title-box">
      <div class="wallet-title-left">
        <div class="title-left">
          <div class="token">
            <img src="@/assets/mybox/home/musd52x52-max.png" />
          </div>
          <div class="mony">400.00</div>
        </div>
        <div class="title-right" @click="recharge">
          <img src="@/assets/mybox/home/add.png" />
        </div>
      </div>
      <div class="wallet-title-right">
        <img src="@/assets/mybox/home/news-max.png" />
        <div class="red-drop"></div>
      </div>
    </div>

    <my-FramePopup
      :isShow="rechargeWindowShow"
      modules="RechargeWindow"
      title="Recharge MUSD"
      @hide="hide"
    >
    </my-FramePopup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rechargeWindowShow: false,
    };
  },
  methods: {
    recharge() {
      this.rechargeWindowShow = !this.rechargeWindowShow;
    },
    hide(){
      this.rechargeWindowShow = !this.rechargeWindowShow;
    }
  },
};
</script>
<style lang="scss" scoped>
.wallet-title {
  width: 100%;
  .wallet-title-box {
    width: 100%;
    display: flex;
    align-items: center;
    .wallet-title-left {
      display: flex;
      align-items: center;
      margin-right: 0.2rem;
      .title-left {
        width: 1.7rem;
        height: 0.48rem;
        display: flex;
        align-items: center;
        background-image: url("@/assets/mybox/home/bag1.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .token {
          width: 0.32rem;
          height: 0.32rem;
          margin: 0 0.1rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .mony {
          font-size: 0.28rem;
          color: white;
        }
      }
      .title-right {
        width: 0.4rem;
        height: 0.4rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .wallet-title-right {
      position: relative;
      width: 0.4rem;
      height: 0.4rem;

      img {
        width: 100%;
        height: 100%;
      }
      .red-drop {
        position: absolute;
        width: 0.1rem;
        height: 0.1rem;
        top: 2px;
        right: 4px;
        border-radius: 50%;
        background: red;
      }
    }
  }
}
</style>
